import './timeseries_chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.TweetsPerTagView extends Monitoring.Views.Charts.TimeseriesChartView
  valueField: 'count'
  chartOptions: {
    yAxis:
      min: 0
    plotOptions:
      spline:
        marker:
          enabled: false
  }

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.ugc_group')
    @title_en = I18n.t('monitoring.dashboard.charts.ugc_group', {'locale': 'en'})
    super(@options)
    @name = 'tweets_per_tag'
    if @searchQuery.get('labels').length > 0
      @facets.label.terms = _.filter(@facets.label.terms, (term) => @searchQuery.get('labels').indexOf(term.term) != -1)

  _dataIsEmpty: ->
    @facets['label'].terms.length == 0

  addSeries: ->
    if @_dataIsEmpty()
      @$el.removeClass('processing')
    else
      _.each(@facets['label'].terms, (label) =>
        query = @searchQuery.deepCopy()
        query.set('labels' , [label.term])
        query.set('interval', @intervalParam)
        @ajaxCall("/monitoring/dashboard/charts/tpm/", query.toJSON(), (response) =>
          @addSerie(label.term, response.values, @facets['label'].terms.length)
          @date_from_realtime = response.date_from_realtime if response.date_from_realtime
          @date_to_realtime = response.date_to_realtime if response.date_to_realtime
        )
      )

    return this

  getNewQuery: (event) ->
    query = super(event)
    query.set('labels' , [])
    query.addLabel(event.point.series.name)
    return query